import { StoryblokImageLink } from './StoryblokImageLink'
export default StoryblokImageLink
